/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @interface ReactRendererAPI
 * @hideconstructor
 * @classdesc  API class that is used to provide a renderer provider extension point
 */
define([], () => {
	class ReactRendererAPI {

		/**
		 * 
		 * @function ReactRendererAPI#canRender
		 * @description Indicates if there is a registered provider that can render the state
		 * @param {Object} state An object that contains the renderer state information
		 * @returns {Boolean} canRender
		 */
		canRender() {}

		/**
		 * @function ReactRendererAPI#getComponentList
		 * @description Get the list of react components to be rendered
		 * @param {Object} state renderer state
		 * @return  {Component[]} children An array of react components that will be placed in the cell
		 *
		 */
		getComponentList() {}

		/**
		 * 
		 * @function ReactRendererAPI#registerProvider
		 * @description Register a  renderer provider
		 * @param {Renderer} renderer - instance of a class that has a getComponent() function
		 */
		registerProvider() {}

		/**
		 * @public
		 * @function ReactRendererAPI#deregisterProvider
		 * @description Deregister a  renderer provider
		 * @returns {Renderer} renderer
		 */
		deregisterProvider() {}

	}

	return ReactRendererAPI;
});
